module.exports = __webpack_public_path__ + "static/media/Tri Delta Logo.dc47e372.jpeg";